import React from 'react';
import { Menu, Icon } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import logo from 'images/logo.png';
import dataStorage from 'misc/data-storage';
import { hasPermission } from '../../src-common/components/helpers/Permissions';

const { SubMenu } = Menu;

const propTypes = {
};

@autobind
class SideBar extends BaseComponent {
  constructor(props) {
    super(props);
  }

  removeNoPermissionPages(subMenus) {
    for (let i = subMenus.length - 1; i >= 0; i--) {
      const { href } = subMenus[i];
      const pathname = href.lastIndexOf('?') >= 0 ? href.substring(0, href.lastIndexOf('?')) : href;

      if (!hasPermission(pathname)) {
        subMenus.splice(i, 1);
      }
    }
  }

  renderPatientsSubMenus() {
    const subMenus = [];
    subMenus.push({ title: 'New Patient', href: '/patients/add_patient' });
    subMenus.push({ title: 'Patient - Processing', href: '/patients/patients?type=PROCESSING' });
    subMenus.push({ title: 'Patient - All', href: '/patients/patients?type=ALL' });
    subMenus.push({ title: 'Search Patients', href: '/patients/search_patients' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Patients', 'user');
  }

  renderCaregiversSubMenus() {
    const subMenus = [];
    subMenus.push({ title: 'New Caregiver', href: '/caregivers/add_caregiver' });
    subMenus.push({ title: 'Caregiver - Processing', href: '/caregivers/caregivers?type=PROCESSING' });
    subMenus.push({ title: 'Caregiver - All', href: '/caregivers/caregivers?type=ALL' });
    subMenus.push({ title: 'Search Caregivers', href: '/caregivers/search_caregivers' });
    subMenus.push({ title: 'Search New Caregivers', href: '/caregivers/search_new_caregivers' });
    subMenus.push({ title: 'Search Expire Caregivers', href: '/caregivers/search_expire_caregivers' });
    subMenus.push({ title: 'Caregiver Sick Leaves', href: '/caregivers/caregiver_sick_leave_report' });
    subMenus.push({ title: 'Search Efiles', href: '/caregivers/search_efiles' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Caregivers', 'user-add');
  }

  renderVisitsSubMenus() {
    const subMenus = [];
    subMenus.push({ title: 'Search Visits', href: '/visits/search_visits' });
    if (!dataStorage.isTeamAgency()) {
      subMenus.push({ title: 'Search Unbillable Visits', href: '/visits/search_unbillable_visits' });
      subMenus.push({ title: 'Confirm Visits', href: '/visits/confirm_visits' });
    }
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Visits', 'check-square');
  }

  renderEvvsSubMenus() {
    if (dataStorage.isTeamAgency()) {
      return null;
    }

    const subMenus = [];
    subMenus.push({ title: 'Search EVVs', href: '/evv/search_evvs' });
    subMenus.push({ title: 'Export Duty Sheet  ', href: '/evv/export_duty_sheet' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'EVVs', 'check-square');
  }

  renderInvoicesSubMenus() {
    if (dataStorage.isTeamAgency()) {
      return null;
    }

    const subMenus = [];
    subMenus.push({ title: 'Create Invoices', href: '/invoices/create_invoices' });
    subMenus.push({ title: 'Create Admin Fee Invoices', href: '/invoices/create_admin_fee_invoices' });
    subMenus.push({ title: 'Search & Print Invoices', href: '/invoices/search_invoices' });
    subMenus.push({ title: 'Create Electronic Billings', href: '/invoices/create_ebillings' });
    // subMenus.push({ title: 'AR Report', href: '/invoices/account_receivable' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Invoices', 'file-text');
  }

  renderPaymentsSubMenus() {
    if (dataStorage.isTeamAgency()) {
      return null;
    }

    const subMenus = [];
    subMenus.push({ title: 'Add Payment', href: '/payments/add_payment' });
    subMenus.push({ title: 'Search Payments', href: '/payments/search_payments' });
    subMenus.push({ title: 'Upload a 835 ERA File', href: '/payments/upload_era' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Payments', 'money-collect');
  }

  renderReportsSubMenus() {
    const subMenus = [];
    if (!dataStorage.isTeamAgency()) {
      subMenus.push({ title: 'Caregiver Payrolls', href: '/reports/caregiver_payrolls' });
      subMenus.push({ title: 'Account Receivable', href: '/reports/account_receivable' });
    }
    subMenus.push({ title: 'Expiring Authorizations', href: '/reports/search_expiring_auths' });
    subMenus.push({ title: 'Active Masterweeks', href: '/reports/search_active_masterweeks' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Reports', 'file-pdf');
  }

  renderProvidersSubMenus() {
    if (dataStorage.isTeamAgency()) {
      return null;
    }

    const subMenus = [];
    subMenus.push({ title: 'CareBridge Submission', href: '/providers/care_bridge_visits' });
    subMenus.push({ title: 'HHAExchange Submission', href: '/providers/hha_exchange_visits' });
    subMenus.push({ title: 'eMedNy Failures', href: '/providers/emedny_visits' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Providers', 'cloud-upload');
  }

  renderCompaniesSubMenus() {
    const subMenus = [];
    subMenus.push({ title: 'Services', href: '/companies/search_services' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Companies', 'home');
  }

  renderSettingsSubMenus() {
    const subMenus = [];
    subMenus.push({ title: 'Change Password', href: '/settings/change_password' });
    this.removeNoPermissionPages(subMenus);

    return this.renderSubMenuGroup(subMenus, 'Settings', 'setting');
  }

  renderSubMenuGroup(subMenus, name, icon) {
    if (subMenus.length > 0) {
      return (
        <SubMenu
          key={name}
          title={
            <span>
              <Icon type={icon} />
              <span>{name.toUpperCase()}</span>
            </span>
          }
        >
          {subMenus.map((m) => (
            <Menu.Item key={m.title}>
              <styledComp.RouteLink
                width="wrap_content"
                height="wrap_content"
                to={m.href}
              >
                {m.title}
              </styledComp.RouteLink>
            </Menu.Item>
          ))}
        </SubMenu>
      );
    } else {
      return null;
    }
  }

  renderContent() {
    const { ...layoutProps } = this.props;

    return (
      <FlexColContainer
        {...layoutProps}
        width="match_parent" // Needed because layoutProps maybe empty when switching route.
        height="wrap_content" // Needed because layoutProps maybe empty when switching route.
        alignItems="center"
      >
        <FlexRowContainer
          width="match_parent"
          height="64px"
          alignItems="center"
        >
          <styledComp.Img
            width="wrap_content"
            height="wrap_content"
            margin="0 0 0 32px"
            src={logo}
            alt="Logo"
          />
        </FlexRowContainer>

        <Menu
          style={{ width: 256 }}
          theme="dark"
          mode="inline"
          defaultOpenKeys={['Patients']}
        >
          {this.renderPatientsSubMenus()}
          {this.renderCaregiversSubMenus()}
          {this.renderVisitsSubMenus()}
          {this.renderEvvsSubMenus()}
          {this.renderInvoicesSubMenus()}
          {this.renderPaymentsSubMenus()}
          {this.renderReportsSubMenus()}
          {this.renderProvidersSubMenus()}
          {this.renderCompaniesSubMenus()}
          {this.renderSettingsSubMenus()}
        </Menu>
      </FlexColContainer>
    );
  }
}

SideBar.propTypes = propTypes;

export default SideBar;
